var render, staticRenderFns
import script from "./carousel.vue?vue&type=script&lang=js&"
export * from "./carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee2bc9ae')) {
      api.createRecord('ee2bc9ae', component.options)
    } else {
      api.reload('ee2bc9ae', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-2g0LlPeIvmngg/JS/carousel.vue"
export default component.exports